import { CustomError } from './CustomError';

export class VoicePreviewError extends CustomError {
	description = 'There was a problem playing the voice preview';
	name = 'VoicePreviewError';
}
